export default __webpack_public_path__ + "static/media/1928.7f2a8b30.png";